var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuldYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.80064 18.2975C3.80064 18.5435 3.87246 18.7835 4.00961 18.9886L4.68748 19.9922C4.89511 20.2998 5.36653 20.55 5.74106 20.55H8.18003C8.55329 20.55 9.02479 20.3 9.23243 19.9922L9.90792 18.989C10.0241 18.8156 10.1194 18.5057 10.1194 18.2975L10.1245 16.7661H3.79668L3.80064 18.2975ZM6.93686 0.550081C2.90446 0.562309 0 3.79092 0 7.39012C0 9.12389 0.650182 10.7045 1.72274 11.914C2.37649 12.65 3.39724 14.1889 3.78798 15.4866C3.78921 15.4964 3.7917 15.5068 3.79293 15.5172H10.1286C10.1299 15.5068 10.1324 15.497 10.1336 15.4866C10.5241 14.1889 11.5451 12.65 12.1988 11.914C13.2726 10.7381 13.9212 9.15983 13.9212 7.39012C13.9212 3.62059 10.7929 0.538479 6.93686 0.550081ZM6.96059 4.30035C5.2153 4.30035 3.79668 5.70244 3.79668 7.39051C3.79668 7.76906 3.51193 8.05034 3.1639 8.05034C2.81587 8.05034 2.53112 7.76906 2.53112 7.42527C2.53112 5.01253 4.51845 3.08499 6.96059 3.08499C7.31035 3.08499 7.59337 3.36467 7.59337 3.71005C7.59337 4.05544 7.30861 4.30035 6.96059 4.30035Z",
    fill: "#EDB650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuldYellow);
export default __webpack_public_path__ + "static/media/buld-yellow.c4e89da8043a91cb6fbff588e2a9428b.svg";
export { ForwardRef as ReactComponent };